import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {BehaviorSubject, catchError, EMPTY, isEmpty, take, tap} from "rxjs";
import { IBaseSearchRequest } from 'src/app/core/models/base';
import { IEmployee, Language } from '../models/employee';
import { EmployeeService } from '../services/employee.service';
const LANGUAGE_KEY = 'lang';
@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class EmployeeStoreService {

  constructor(private employeeService : EmployeeService) { }

  private _currentEmployee$ = new BehaviorSubject<IEmployee>(null);
  public currentEmployee$ = this._currentEmployee$.asObservable();

  get languages() {
    return Language;
  }

  getCurrentEmployee(){
    this.employeeService.getCurrentEmployee()
    .pipe(
      catchError(err => {
        return EMPTY
      })
    )
    .subscribe(employee => {
      this._currentEmployee$.next(employee)
      this.saveLanguage(employee.language == this.languages.french ? "fr" : "de")
    })
  }

  resetCurrentEmployee(){
    this._currentEmployee$.next(null);
  }

  public saveLanguage(language : string): void{
    window.localStorage.removeItem(LANGUAGE_KEY);
    window.localStorage.setItem(LANGUAGE_KEY, language);
  }

  public getLanguage() : string | null{
    return window.localStorage.getItem(LANGUAGE_KEY);
  }
}
